import script from "./terminal-distribution-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./terminal-distribution-chart.vue?vue&type=script&lang=ts&setup=true"

import "./terminal-distribution-chart.vue?vue&type=style&index=0&id=55669fdc&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55669fdc"]])

export default __exports__